import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'sorting-action.ascending-read-only-label.non-final': {
    id: 'sorting-action.ascending-read-only-label.non-final',
    defaultMessage: '{fieldName} is sorted ascending',
    description:
      'Accessible label for a read-only ascending sort indicator in a database field header'
  },
  'sorting-action.descending-read-only-label.non-final': {
    id: 'sorting-action.descending-read-only-label.non-final',
    defaultMessage: '{fieldName} is sorted descending',
    description:
      'Accessible label for a read-only descending sort indicator in a database field header'
  },
  'sorting-action.sort-ascending-label.non-final': {
    id: 'sorting-action.sort-ascending-label.non-final',
    defaultMessage: 'Sort {fieldName} ascending',
    description:
      'Accessible label for the action that sorts a database field in ascending order'
  },
  'sorting-action.sort-descending-label.non-final': {
    id: 'sorting-action.sort-descending-label.non-final',
    defaultMessage: 'Sort {fieldName} descending',
    description:
      'Accessible label for the action that sorts a database field in descending order'
  }
});
